





































import { Component, Prop, Vue } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { getMenuIconName } from '@/utils/iconHelper';

@Component({
  components: {}
})
export default class FeaturesList extends Vue {
  @Prop() features!: any[];

  @Prop({ default: true }) showCheck?: boolean;

  getMenuIconName = getMenuIconName;

  disconnectProvider() {
    eventBus.$emit('closeModal');
    this.$router.push('/settings/apps');
  }
}
